// extracted by mini-css-extract-plugin
module.exports = {"text-logo-ecommerce":"AuthLogos_text-logo-ecommerce__3Ok5S","text-auth-warning":"AuthLogos_text-auth-warning__3A5bR","mt-4_5":"AuthLogos_mt-4_5__3hNoM"};